import { useEffect, useState } from "react";
import { WifiOff, RefreshCw, CloudUpload } from "lucide-react";
import { toast } from "sonner";
import { getQueue, flushQueue } from "../lib/offline";
import { pendingDiaryCount, flushDiaryQueue, DIARY_QUEUE_EVENT } from "../lib/diaryQueue";

export const OfflineBanner = () => {
    const [online, setOnline] = useState(navigator.onLine);
    const [queued, setQueued] = useState(getQueue().length);
    const [diaryQueued, setDiaryQueued] = useState(0);
    const [syncing, setSyncing] = useState(false);

    useEffect(() => {
        const refreshDiary = () => pendingDiaryCount().then(setDiaryQueued).catch(() => {});
        const sync = async () => {
            const hasLegacy = getQueue().length > 0;
            const hasDiary = (await pendingDiaryCount().catch(() => 0)) > 0;
            if (!hasLegacy && !hasDiary) return;
            setSyncing(true);
            let synced = 0, remaining = 0;
            if (hasLegacy) { const r = await flushQueue(); synced += r.synced; remaining += r.remaining; }
            if (hasDiary) { const r = await flushDiaryQueue(); synced += r.sent; remaining += r.remaining; }
            setSyncing(false);
            refreshDiary();
            if (synced > 0) toast.success(`Odesláno ${synced} offline záznamů`);
            if (remaining > 0 && navigator.onLine) toast.warning(`${remaining} záznamů stále čeká — zkontrolujte stavební deník`);
        };
        const onOnline = () => { setOnline(true); sync(); };
        const onOffline = () => setOnline(false);
        const onQueue = (e) => setQueued(e.detail);
        window.addEventListener("online", onOnline);
        window.addEventListener("offline", onOffline);
        window.addEventListener("offline-queue-changed", onQueue);
        window.addEventListener(DIARY_QUEUE_EVENT, refreshDiary);
        refreshDiary();
        if (navigator.onLine) sync();
        return () => {
            window.removeEventListener("online", onOnline);
            window.removeEventListener("offline", onOffline);
            window.removeEventListener("offline-queue-changed", onQueue);
            window.removeEventListener(DIARY_QUEUE_EVENT, refreshDiary);
        };
    }, []);

    const total = queued + diaryQueued;
    if (online && total === 0 && !syncing) return null;

    return (
        <div data-testid="offline-banner"
             className={`px-4 md:px-6 py-1.5 text-[11px] font-semibold uppercase tracking-wider flex items-center gap-2 ${online ? "bg-slate-800 text-amber-300" : "bg-amber-500 text-slate-900"}`}>
            {!online ? (
                <>
                    <WifiOff className="w-3.5 h-3.5" />
                    <span>Jste offline – zobrazují se uložená data</span>
                    {total > 0 && <span className="ml-auto bg-slate-900 text-amber-400 px-2 py-0.5 rounded-sm" data-testid="offline-queue-count">{total} čeká na odeslání</span>}
                </>
            ) : syncing ? (
                <>
                    <RefreshCw className="w-3.5 h-3.5 animate-spin" />
                    <span>Odesílám offline záznamy…</span>
                </>
            ) : (
                <>
                    <CloudUpload className="w-3.5 h-3.5" />
                    <span>{total} záznamů čeká na odeslání</span>
                    <button onClick={() => window.dispatchEvent(new Event("online"))} className="ml-auto underline" data-testid="offline-sync-now">Odeslat teď</button>
                </>
            )}
        </div>
    );
};

export default OfflineBanner;
